"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTheme = exports.getCSSVariable = exports.pickThemeColors = exports.themeColorFields = exports.staticColorFields = exports.defaultTheme = exports.loadThemeBase = exports.loadCustomTheme = void 0;
const lodash_1 = __importDefault(require("lodash"));
const helpers_1 = require("../helpers");
const utils_1 = require("../utils");
const themes_1 = require("./themes");
const custom_1 = require("./themes/custom");
function loadCustomTheme(color) {
    return custom_1.createThemeFromColor(color, 'custom', 'Custom');
}
exports.loadCustomTheme = loadCustomTheme;
function loadThemeBase(theme, { preferredDarkTheme, preferredLightTheme, prefersDarkTheme, } = {}) {
    const _theme = theme || utils_1.constants.DEFAULT_THEME_PAIR;
    if (_theme.id === 'custom' && _theme.color) {
        return loadCustomTheme(_theme.color);
    }
    if (_theme.id === 'auto' || !_theme.id) {
        const _preferredDarkTheme = preferredDarkTheme
            ? preferredDarkTheme.id === 'custom' && preferredDarkTheme.color
                ? loadCustomTheme(preferredDarkTheme.color)
                : themes_1.themes[preferredDarkTheme.id]
            : undefined;
        const _preferredLightTheme = preferredLightTheme
            ? preferredLightTheme.id === 'custom' && preferredLightTheme.color
                ? loadCustomTheme(preferredLightTheme.color)
                : themes_1.themes[preferredLightTheme.id]
            : undefined;
        const darkTheme = _preferredDarkTheme || themes_1.themes[utils_1.constants.DEFAULT_DARK_THEME];
        const lightTheme = _preferredLightTheme || themes_1.themes[utils_1.constants.DEFAULT_LIGHT_THEME];
        const _prefersDarkTheme = typeof prefersDarkTheme === 'boolean' ? prefersDarkTheme : helpers_1.isNight();
        return _prefersDarkTheme ? darkTheme : lightTheme;
    }
    return (themes_1.themes[_theme.id] ||
        loadThemeBase({ id: 'auto', color: _theme.color }, { preferredDarkTheme, preferredLightTheme, prefersDarkTheme }));
}
exports.loadThemeBase = loadThemeBase;
exports.defaultTheme = loadThemeBase(utils_1.constants.DEFAULT_THEME_PAIR);
exports.staticColorFields = [
    'black',
    'blue',
    'blueGray',
    'brown',
    'gray',
    'green',
    'lightRed',
    'orange',
    'pink',
    'purple',
    'red',
    'teal',
    'white',
    'yellow',
];
exports.themeColorFields = [
    'primaryBackgroundColor',
    'primaryForegroundColor',
    'backgroundColor',
    'backgroundColorDarker1',
    'backgroundColorDarker2',
    'backgroundColorDarker3',
    'backgroundColorDarker4',
    'backgroundColorDarker5',
    'backgroundColorLess1',
    'backgroundColorLess2',
    'backgroundColorLess3',
    'backgroundColorLess4',
    'backgroundColorLess5',
    'backgroundColorLighther1',
    'backgroundColorLighther2',
    'backgroundColorLighther3',
    'backgroundColorLighther4',
    'backgroundColorLighther5',
    'backgroundColorMore1',
    'backgroundColorMore2',
    'backgroundColorMore3',
    'backgroundColorMore4',
    'backgroundColorMore5',
    'backgroundColorTransparent05',
    'backgroundColorTransparent10',
    'backgroundColorTintedRed',
    'foregroundColor',
    'foregroundColorMuted10',
    'foregroundColorMuted25',
    'foregroundColorMuted40',
    'foregroundColorMuted65',
    'foregroundColorTransparent05',
    'foregroundColorTransparent10',
    ...exports.staticColorFields,
];
const pickThemeColors = (theme) => lodash_1.default.pick(theme, exports.themeColorFields);
exports.pickThemeColors = pickThemeColors;
const cssVariablesTheme = {};
exports.themeColorFields.forEach(field => {
    cssVariablesTheme[field] = `var(--theme-${lodash_1.default.kebabCase(field)})`;
    cssVariablesTheme[`inverted-${field}`] = `var(--theme-inverted-${lodash_1.default.kebabCase(field)})`;
});
function getCSSVariable(color, isInverted) {
    const field = color && typeof color === 'string'
        ? isInverted
            ? `inverted-${color}`
            : color
        : undefined;
    if (field && field in cssVariablesTheme)
        return cssVariablesTheme[field];
    return color;
}
exports.getCSSVariable = getCSSVariable;
function transformTheme(theme, themeTransformer) {
    if (themeTransformer === 'invert' ||
        (themeTransformer === 'force-dark' && !theme.isDark) ||
        (themeTransformer === 'force-light' && theme.isDark)) {
        return theme.invert();
    }
    return theme;
}
exports.transformTheme = transformTheme;
//# sourceMappingURL=helpers.js.map